import { useEffect, useState } from "react";
import { sendApiRequest, thisIsDevEnvironment } from "../lib/helper";
import { useAuthenticationContext } from "../providers/authenticationprovider";

export function usePrivacy() {
    const [originalValue, setOriginalValue] = useState<boolean>();
    const authenticationContext = useAuthenticationContext();

    useEffect(() => {
        const email = thisIsDevEnvironment ? authenticationContext.Result?.KeplerAuthStatus.account.username : authenticationContext.Result?.CanvasAuthStatus?.userEmail;
        if (email) {
            sendApiRequest(`/api/sql/getPrivacySetting?userEmail=${email}`, "GET").then((res) => {
                setOriginalValue(res.length > 0);
            }).catch(err => {
                console.error(`Error in usePrivacy hook`, err);
                setOriginalValue(true);
            });
        }
    }, [authenticationContext?.Result?.CanvasAuthStatus?.userEmail, authenticationContext.Result?.KeplerAuthStatus?.account?.username])

    return originalValue;
}